<template>
  <div class="modal fade" id="tipsModal" tabindex="-1" aria-labelledby="tipsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content tips-guide-modal">
        <div class="modal-header">
          <h5 class="modal-title" id="tipsModalLabel">{{ $t("tips.tips") }}</h5>
          <i class="bi-x close-modal" data-bs-dismiss="modal" :aria-label="$t('ui.cancel')"></i>
        </div>
        <div class="modal-body">
          <p class="tips-guide-intro">{{ $t("tips.guideIntro") }}</p>
          <ul class="tips-guide-list">
            <li v-for="item in guideItems" :key="item.key" class="tips-guide-item">
              <h6 class="tips-guide-title">{{ item.title }}</h6>
              <p class="tips-guide-text">{{ item.text }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const GUIDE_KEYS = [
  "create",
  "edit",
  "details",
  "activityLog",
  "check",
  "delete",
  "reorder",
  "calendarToggle",
  "calendarNav",
  "calendarPick",
  "customLists",
  "notesOpen",
  "notesWrite",
  "notesFilter",
  "notesFocus",
  "settings",
  "profile",
  "export",
];

export default {
  name: "tipsModal",
  computed: {
    guideItems() {
      return GUIDE_KEYS.map((key) => ({
        key,
        title: this.$t(`tips.guide.${key}.title`),
        text: this.$t(`tips.guide.${key}.text`),
      }));
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 560px;
  max-height: 70vh;
}

.tips-guide-modal {
  max-height: 70vh;
}

.modal-body {
  overflow-y: auto;
  max-height: calc(70vh - 64px);
  padding: 12px 16px 20px;
}

.tips-guide-intro {
  margin: 0 0 12px;
  font-size: 14px;
  color: var(--m-muted, rgba(60, 60, 67, 0.65));
  line-height: 1.4;
}

.tips-guide-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tips-guide-item {
  padding: 10px 0;
  border-bottom: 1px solid var(--m-hairline, rgba(60, 60, 67, 0.14));
}

.tips-guide-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.tips-guide-title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 650;
  line-height: 1.3;
}

.tips-guide-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.45;
  color: inherit;
  opacity: 0.88;
}

.dark-theme .tips-guide-intro {
  color: rgba(235, 235, 245, 0.55);
}

.dark-theme .tips-guide-item {
  border-bottom-color: rgba(84, 84, 88, 0.45);
}
</style>
